import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FontIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.943 8.5L16 8.5L16 9.667M11.943 8.5H8V9.667M11.943 8.5L11.943 15.5M11.943 15.5H12.963M11.943 15.5H10.999M6 20H18C19.105 20 20 19.105 20 18V6C20 4.895 19.105 4 18 4H6C4.895 4 4 4.895 4 6V18C4 19.105 4.895 20 6 20Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

FontIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FontIcon);
